import React from 'react';
import { Spin, Alert, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

interface DashboardStateProps {
  loading: boolean;
  error: string | null;
  onRetry: () => void;
}

const DashboardState: React.FC<DashboardStateProps> = ({ loading, error, onRetry }) => {
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-64">
        <Alert
          message="Error Loading Finance Dashboard"
          description={error}
          type="error"
          showIcon
          action={
            <Button 
              size="small" 
              danger 
              icon={<ReloadOutlined />}
              onClick={onRetry}
            >
              Retry
            </Button>
          }
        />
      </div>
    );
  }

  return null;
};

export default DashboardState;
